import Reveal from "@/components/Reveal";
import { Check, ArrowRight } from "lucide-react";
import { BASIC_FLAVORS, FANCY_FLAVORS } from "@/data/site";

const CARDS = [
    {
        id: "basic",
        title: "Basic Cupcakes",
        price: "$25",
        per: "per dozen",
        blurb: "Perfect when you want something simple and delicious.",
        includes: ["No filling", "One frosting color", "No decorations"],
        flavors: BASIC_FLAVORS,
        featured: false,
    },
    {
        id: "fancy",
        title: "Fancy Cupcakes",
        price: "$40",
        per: "per dozen",
        blurb: "Take your cupcakes to the next level!",
        includes: ["Filled", "Up to two frosting colors", "Decorated"],
        flavors: FANCY_FLAVORS,
        featured: true,
    },
];

export default function MenuCupcakes() {
    return (
        <div className="grid md:grid-cols-2 gap-8">
            {CARDS.map((card, i) => (
                <Reveal key={card.id} delay={i * 0.12}>
                    <article
                        data-testid={`menu-card-${card.id}`}
                        className={`relative h-full rounded-[2rem] p-8 sm:p-10 transition-[transform,box-shadow] duration-500 hover:-translate-y-2 ${
                            card.featured
                                ? "bg-[#3D2318] text-[#FFFDF9] shadow-[0_30px_70px_rgba(61,35,24,0.35)]"
                                : "bg-white border border-[#F2E1E6] shadow-[0_16px_40px_rgba(61,35,24,0.08)]"
                        }`}
                    >
                        {card.featured && (
                            <span className="absolute -top-3 right-8 rounded-full bg-[#D4AF37] px-4 py-1 text-[10px] font-bold uppercase tracking-[0.2em] text-[#2C180F]">
                                Most Loved
                            </span>
                        )}
                        <h3 className={`font-display text-2xl sm:text-3xl font-bold ${card.featured ? "text-[#F8D7E3]" : "text-[#3D2318]"}`}>{card.title}</h3>
                        <p className="mt-4 flex items-baseline gap-2">
                            <span className={`font-display text-5xl font-bold ${card.featured ? "text-[#D4AF37]" : "text-[#C95B7D]"}`} data-testid={`menu-price-${card.id}`}>
                                {card.price}
                            </span>
                            <span className={`text-sm ${card.featured ? "text-[#FFFDF9]/60" : "text-[#8C6A5D]"}`}>{card.per}</span>
                        </p>
                        <p className={`mt-3 text-sm leading-relaxed ${card.featured ? "text-[#FFFDF9]/75" : "text-[#6B4A3E]"}`}>{card.blurb}</p>

                        <p className={`mt-6 text-[10px] font-bold uppercase tracking-[0.25em] ${card.featured ? "text-[#D4AF37]" : "text-[#C59B27]"}`}>Includes</p>
                        <ul className="mt-3 space-y-2">
                            {card.includes.map((item) => (
                                <li key={item} className={`flex items-center gap-2.5 text-sm ${card.featured ? "text-[#FFFDF9]/85" : "text-[#6B4A3E]"}`}>
                                    <Check className={`h-4 w-4 shrink-0 ${card.featured ? "text-[#D4AF37]" : "text-[#C95B7D]"}`} />
                                    {item}
                                </li>
                            ))}
                        </ul>

                        <p className={`mt-6 text-[10px] font-bold uppercase tracking-[0.25em] ${card.featured ? "text-[#D4AF37]" : "text-[#C59B27]"}`}>Flavors</p>
                        <div className="mt-3 flex flex-wrap gap-2">
                            {card.flavors.map((f) => (
                                <span
                                    key={f}
                                    className={`rounded-full px-3.5 py-1.5 text-xs font-medium ${
                                        card.featured ? "bg-[#FFFDF9]/10 text-[#F8D7E3] border border-[#F8D7E3]/25" : "bg-[#FDF0F4] text-[#C95B7D] border border-[#F2E1E6]"
                                    }`}
                                >
                                    {f}
                                </span>
                            ))}
                            {card.featured && (
                                <span className="rounded-full px-3.5 py-1.5 text-xs font-medium bg-[#D4AF37]/15 text-[#D4AF37] border border-[#D4AF37]/30">…and more!</span>
                            )}
                        </div>

                        <a
                            href="#order"
                            data-testid={`menu-order-${card.id}`}
                            className={`group mt-8 inline-flex items-center gap-2 text-sm font-semibold transition-colors duration-300 ${
                                card.featured ? "text-[#D4AF37] hover:text-[#F8D7E3]" : "text-[#C95B7D] hover:text-[#3D2318]"
                            }`}
                        >
                            Request a dozen
                            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                        </a>
                    </article>
                </Reveal>
            ))}
        </div>
    );
}
